import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { BehaviorSubject, lastValueFrom, Subject } from 'rxjs';

// import * as packageFile from 'package.json';
import { DOCUMENT } from '@angular/common';
import { apiConstant } from '../../config/apiconfig.const';
import { ProductsService } from '../../sag/products/products.service';

@Injectable({
  providedIn: 'root'
})
export class CommonService {
  data: any = [];
  previewType = new BehaviorSubject('preview');
  // packageInfo = packageFile;
  themeActiveStatus: number = 0;
  userInfo$ : any = new BehaviorSubject({});
  cartQty$: any = new BehaviorSubject("");
  showViewPoint: any = new Subject();
  constructor(private http: HttpClient,
    private products : ProductsService,
  @Inject(DOCUMENT) private doc: any) { }

  getDateFormat() {
    if (this.data.length > 0) {
      return this.data.map((ele) => ele.type == 'date' ? ele.selectedFormat : false).filter((ele) => ele).toString();
    } else {
      return "";
    }
  }
 getEnvironment(){
    return 'web';
    }
  createLinkForCanonicalURL() {
    let link: HTMLLinkElement = this.doc.createElement('link');
    link.setAttribute('rel', 'canonical');
    this.doc.head.appendChild(link);
    link.setAttribute('href', this.doc.URL);
  }

  //check Validation Checker On Reactive Form
  validationChecker(id, self) {
    let groupName = document.getElementById(id).getAttribute("data-formGroup");
    if (groupName && self[groupName].invalid) {
      return findInvalidControls(groupName, self[groupName]);
    }
    else {
      return alert(JSON.stringify(self[groupName].getRawValue()));
    }

    function findInvalidControls(groupName, groupList) {
      const controls = groupList.controls;
      for (const name in controls) {
        if (controls[name].invalid) {
          let nodeEle = document.getElementsByName(name);
          nodeEle.forEach((node) => {
            if (node.getAttribute("data-groupID") == groupName + "~" + name) {
              node.focus();
              return false;
            }
          });
        }
      }
    }
  } 

  async getUserInfo(){
    await lastValueFrom(this.products.getUserInfo(-1)).then(res => {
      if (res['data'] !== '' && res['data'] !== undefined) {
        this.userInfo$.next(res);
      }
    });
  }

  login(data) {
    return this.http.post<any>(`${apiConstant.loginUrl}`+ 'api/login', JSON.parse(JSON.stringify(data)))
  } 

  public authAppsSessions(appCode: string, data: Object) {
    return this.http.post(`${apiConstant.genmasterTokenUrl}${appCode.toLowerCase()}/storeTokenInSession`, data);
  }

  getMenuJson(formData) {
    return this.http.post(apiConstant.restProjectUrl + 'projectmenu/createMenuJson', formData);
  }

  convertDate(date) {
    return new Date(date);
  }

  convertMaxDate(date) {
    return new Date(date);
  } 
  
  updateImageDisplay(event, self) {
    let fileList: any = [];
    let formGroup = event.target.getAttribute("data-groupId") ? event.target.getAttribute("data-groupId").split("~")[0] : false;
    let formControlName = event.target.name;
    let fileTypeList = event.target.accept.split(",");
    let bytes = (1024 * 1024) * event.target.size || 1; // default 1MB bytes store 
    let curFiles = event.target.files;
    let isPreview = event.target.getAttribute("data-preview") ? JSON.parse(event.target.getAttribute("data-preview")) : false;
    let preview: HTMLElement;
    let multiple = event.target.hasAttribute('multiple') ? JSON.parse(event.target.hasAttribute('multiple')) : false;
    let imgBlob = (event.target.getAttribute("data-uploadFormat") && event.target.getAttribute("data-uploadFormat") == "blob" ? true : false);

    if (isPreview) {
      let exitingPreview = event.target.parentNode.querySelector('.preview');
      if (exitingPreview) {
        event.target.parentNode.removeChild(exitingPreview);
      }
      preview = document.createElement('div');
      preview.classList.add("preview");
    }

    if (curFiles.length === 0) {
      if (isPreview) {
        const para = document.createElement('p');
        para.textContent = 'No files currently selected for upload';
        preview.appendChild(para);
      } else {
        alert("No files currently selected for upload");
      }
    }
    else {
      let ul: HTMLElement;
      if (isPreview) {
        ul = document.createElement('ul');
        ul.classList.add("previewUl");
        preview.appendChild(ul);
      }
      for (const file of curFiles) {

        let li: HTMLElement;
        let para: HTMLElement;
        if (isPreview) {
          li = document.createElement('li');
          li.classList.add("previewLi");
          para = document.createElement('p');
        }


        let sizeObj = returnFileSize(file.size);
        !sizeObj.res ? alert(sizeObj.msg) : false;
        if (validFileType(file.type) && sizeObj.res) {
          // const blobFile = new Blob([file], { type: file.type });

          isPreview ? para.textContent = ` ${file.name}, size ${sizeObj.msg}.` :
            false;
          if (file.type.split("/")[0] === 'text') {

            let previewDiv: HTMLElement;
            previewDiv = document.createElement('div');
            const reader = new FileReader();
            reader.readAsText(file);
            reader.onload = function () {
              if (multiple && curFiles.length > 1) {
                fileList.push(file);
              } else {
                self[formGroup].get(formControlName).patchValue([file]);
              }
              previewDiv.textContent = reader.result as string;
            };
            if (isPreview) {
              previewDiv.style.width = "20vw";
              previewDiv.style.height = "20vh";
              previewDiv.style.overflow = "auto";
              li.appendChild(previewDiv);
            }

          }
          else if (file.type.split("/")[0] == "image") {
            const previewDiv = document.createElement('img');
            let reader = new FileReader();
            reader.onload = function () {
              if (multiple && curFiles.length > 1) {
                imgBlob ? fileList.push(file) : fileList.push(reader.result);
                previewDiv.textContent = reader.result as string;
                self[formGroup].patchValue({
                  [formControlName]: fileList
                });
              }
              else {
                imgBlob ?
                  self[formGroup].get(formControlName).patchValue([file]) :
                  self[formGroup].get(formControlName).patchValue(reader.result);
                previewDiv.textContent = reader.result as string;

              }
            };
            reader.readAsDataURL(file);
            if (isPreview) {
              previewDiv.style.width = "20vw";
              previewDiv.style.height = "20vh";
              previewDiv.src = URL.createObjectURL(file);
              li.appendChild(previewDiv);
            }
          } else {
            if (multiple && curFiles.length > 1) {
              fileList.push(file);
            } else {
              self[formGroup].get(formControlName).patchValue(file);
            }
          }

          isPreview ? li.appendChild(para) : false;
        } else {
          if (isPreview) {
            para.textContent = `${file.name}: Not a valid file. Update your selection.`;
            para.style.color = "red";
            li.appendChild(para);

          } else {
            alert(`${file.name}: Not a valid file. Update your selection.`);
          }
        }
        isPreview ? ul.appendChild(li) : false;
      }

    }
    isPreview ? event.target.parentNode.append(preview) : false;

    function returnFileSize(number) {
      if (number < 1024) {
        return { res: true, msg: number + 'bytes' };
      } else if (number >= 1024 && number < 1048576) {
        return { res: true, msg: (number / 1024).toFixed(1) + 'KB' };
      } else if (number >= 1048576 && number < bytes) {
        return { res: true, msg: (number / 1048576).toFixed(1) + 'MB' };
      }
      else if (number > bytes) {
        return { res: false, msg: `max size than ${event.target.size} MB` };
      }
    }
    function validFileType(fileType) {
      return fileTypeList.includes(fileType);
    }

  }
   ConfirmPasswordValidator(controlName: string, matchingControlName: string) {
    return (formGroup: FormGroup) => {
      let control = formGroup.controls[controlName];
      let matchingControl = formGroup.controls[matchingControlName]
      if (
        matchingControl.errors &&
        !matchingControl.errors.confirmPasswordValidator
      ) {
        return;
      }
      if (control.value !== matchingControl.value) {
        matchingControl.setErrors({ confirmPasswordValidator: true });
      } else {
        matchingControl.setErrors(null);
      }
    };
  }

  getThemeStatus() {
    let data = {
      "projectName": null//this.packageInfo['default'].name
    }
    this.http.post(apiConstant.restProjectUrl + 'projectmenu/get-theme-status', data).subscribe((res) => {
      if (res && res['themeActive'] == 1) {
        this.themeActiveStatus = res['themeActive'];
      }
    });
  }

  eyeBlinkIconOnPassword(evetData) {
    let ctrlId: any = evetData.target.parentElement.previousSibling;
    if (ctrlId.type != 'text' && evetData.target.className == 'fa fa-eye-slash') {
      ctrlId.type = 'text';
      evetData.target.className = 'fa fa-eye'
    } else {
      evetData.target.className = 'fa fa-eye-slash';
      ctrlId.type = 'password';
    }
  }

  getMetaJson() {
    let data = {
      "projectName" :"genamerkila",
      "staticonpage":0
    }
    return this.http.post(apiConstant.projectBaseUrl + 'metatags/get-meta-json',data).toPromise();
    }
}
